import React from "react";
import { TUnitListingMdl } from "admin/units/_models/UnitListingMdl";
import { UnitHeaderDetails } from "units/UnitHeaderDetails";
import { usePropertyStore } from "properties/propertyPage/PropertyContext";
import { UnitHeaderPrices } from "units/UnitHeaderPrices";
import { UnitMapper } from "units/unitMapper";

type Props = {
    unit: TUnitListingMdl;
};

export function UnitHeader({ unit }: Props) {
    const { property } = usePropertyStore();

    return (
        <div className="flex flex-col mb-10 gap-5 md:gap-0 md:flex-row">
            <UnitHeaderPrices item={UnitMapper.toHeaderPrice(unit, "unit", property)} />
            <UnitHeaderDetails item={UnitMapper.toHeaderDetails(unit, "unit", property)} />
        </div>
    );
}
